import { useUpdateSurfacePreferences } from "@/components/preferences/usePreferences.tsx";
import { Toggle } from "@/components/ui/toggle.tsx";
import { errorToast } from "@/components/ui/toast.tsx";
import { useState } from "react";
import { useSendInBackgroundEnabled } from "./useSendInBackground.ts";

export const SendInBackgroundToggle = () => {
  const sendInBackground = useSendInBackgroundEnabled();
  const updateGlobalPreferences = useUpdateSurfacePreferences("global");
  const [isUpdating, setIsUpdating] = useState(false);

  const handleToggle = async (checked: boolean) => {
    setIsUpdating(true);
    try {
      await updateGlobalPreferences({ sendInBackground: checked });
    } catch {
      errorToast("Failed to update send preferences. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Toggle
      size="md"
      checked={sendInBackground}
      onCheckedChange={handleToggle}
      disabled={isUpdating}
    />
  );
};
